import styled from 'styled-components';

export const OrderAddressesCreateContainer = styled.div``;

export const OrderAddressesEditContainer = styled.div`
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: flex;
    flex-direction: row;
  }
`;

export const SelectedAddress = styled.div`
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  font-size: 1rem;
`;

export const ShippingAddress = styled.div`
  > div:nth-child(2) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const BillingAddress = styled.div`
  margin-top: 30px;
  > div:nth-child(2) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const EmailAddress = styled.div`
  margin-top: 30px;
`;

export const EmailContainer = styled.div`
  width: 42%;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 90%;
  }
`;

export const AddressContainer = styled.div<{ isSelected: boolean }>`
  padding: 10px;
  border-radius: 5px;
  border: ${({ isSelected }) =>
    isSelected
      ? '2px solid rgba(32, 154, 214, 1)'
      : '1px solid rgba(0, 0, 0, 0.23)'};
  margin-top: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: ${({ isSelected }) =>
    isSelected ? '0px 4px 12px rgba(0, 0, 0, 0.08)' : 'none'};

  width: 100%;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 45%;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 0;
  margin-top: 2rem;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    > * {
      width: 100%;
    }
  }
`;

export const MailingName = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.93);
`;

export const Address = styled.div`
  font-size: 1rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 5px;
`;

export const AddressWrapper = styled.div``;

export const Title = styled.div`
  font-weight: 500;
  font-size: 1.05rem;
  color: rgba(0, 0, 0, 0.93);
  margin: 10px 0px;
`;

export const SelectedAddressContainer = styled.div`
  min-width: 33.3%;

  ${({ theme }) => theme.breakpoints.down('md')} {
    & + & {
      padding: 2rem 0 0 0;
    }
  }
`;

export const ErrorSection = styled.div`
  color: red;
  margin-top: 5px;
`;

export const ModalTitle = styled.div`
  padding: 20px 20px 0px 20px;
  margin-top: 50%;
  font-weight: 500;
  font-size: 1.1rem;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  > span {
    margin-left: 5px;
  }
`;

export const ModalBody = styled.div`
  border-radius: 0px 5px 5px 5px;
  padding: 0px 20px 10px 20px;
  font-weight: 400;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 2%;
  font-weight: 400;
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0px 5px 5px 5px;
  padding: 0px 20px 20px 20px;
  font-weight: 400;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.63);

  font-weight: 400;
  display: flex;
  justify-content: flex-end;
  > div button {
    margin-left: 5px;
  }
`;
